export default __webpack_public_path__ + "static/media/profile-pic.f801dfeb.jpg";